export const createGridRepeat = (length: number): `repeat(${number}, 1fr)` =>
    `repeat(${Math.ceil(length / 3)}, 1fr)`;
